import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

export const PasswordRequirements = ({ password }: { password: string }) => {
	const { t } = useTranslation();
	const requirements = [
		{ label: t('min8'), regex: /.{8,}/ },
		// { label: t('uppercase'), regex: /[A-Z]/ },
		// { label: t('lowercase'), regex: /[a-z]/ },
	];

	return (
		<Box sx={{ mt: 1, mb: 1 }}>
			<ErrorOutlineOutlinedIcon sx={{ color: '#FD3333' }} />
			<span className="ml-4 text-dark">{t('passwordContain')}</span>
			{requirements.map((req) => (
				<Typography
					key={req.label}
					variant="body2"
					className={classNames({
						'text-dark': req.regex.test(password || ''),
						'text-error': !req.regex.test(password || ''),
					})}
					sx={{ display: 'flex', alignItems: 'center', gap: '4px', marginLeft: '38px' }}
				>
					{req.regex.test(password || '') ? (
						<DoneOutlinedIcon className="text-primary" />
					) : (
						<CloseOutlinedIcon className="text-error" />
					)}
					<span>{req.label}</span>
				</Typography>
			))}
		</Box>
	);
};
